import { DxpError } from '../../../core/error/dxp-error';

/**
 * Cosa il cittadino ha risposto alla proposta, come la postazione dell'operatore lo riceve.
 *
 * L'indirizzo vive qui e basta: nella scheda aperta, finché il recap non parte. Il BFF non lo conserva,
 * quindi chiudere la scheda è ciò che lo fa sparire.
 */
export interface SessionReminderAnswer {
  readonly accepted: boolean;
  readonly address: string | null;
}

/**
 * Il recap mentre si compone. Arriva a frammenti dal Motore: `composing` è il tempo in cui la schermata
 * dice che sta succedendo qualcosa, e `ready` quello in cui l'editor si apre. `filtered`: al posto del
 * recap è arrivato l'avviso del filtro dei contenuti del Motore (#1859) — si mostra, ma non si corregge né
 * si spedisce.
 */
export type SessionRecapStatus = 'idle' | 'composing' | 'ready' | 'failed' | 'filtered';

/** Il recap non è arrivato: il Motore non ha risposto, o ha risposto senza un testo da rivedere. */
export class ReminderDraftUnavailableError extends DxpError {
  readonly code = 'REMINDER_DRAFT_UNAVAILABLE';
  constructor() {
    super('The reminder draft could not be produced.');
  }
}

/** Il promemoria non è partito. */
export class ReminderNotSentError extends DxpError {
  readonly code = 'REMINDER_NOT_SENT';
  constructor() {
    super('The reminder could not be sent.');
  }
}
